__webpack_require__.p = "https://embed.myradar.com/forecast/widget/";